<div class="quantity-control">
  <button
    mat-button
    class="control"
    (click)="minus()"
    [disabled]="disabled || quantityControl.value <= 1"
  >
    -
  </button>

  <input
    matInput
    [maxLength]="3"
    xOnlyNumberPattern
    regExp="^([1-9]|[1-9][0-9][0-9]|1000)"
    [formControl]="quantityControl"
    (focusout)="onFocusOut()"
    class="quantity"
    autocomplete="off"
    [readonly]="disabled"
  />

  <button mat-button class="control" (click)="plus()" [disabled]="disabled">+</button>
</div>
